import { Twitter, Facebook, MessageSquare, Image } from 'lucide-react'
import { useUIStore } from '../../stores/uiStore'
import type { Platform } from '../../types'
import clsx from 'clsx'

const platforms: { id: Platform; label: string; icon: typeof Twitter; shortcut: string }[] = [
  { id: 'twitter', label: 'Twitter/X', icon: Twitter, shortcut: '⌘1' },
  { id: 'facebook', label: 'Facebook', icon: Facebook, shortcut: '⌘2' },
  { id: 'forum', label: 'Forum', icon: MessageSquare, shortcut: '⌘3' },
  { id: 'infographic', label: 'Infographic', icon: Image, shortcut: '⌘4' },
]

export default function PlatformTabs() {
  const { activeTab, setActiveTab } = useUIStore()

  return (
    <div className="tabs" role="tablist">
      {platforms.map(({ id, label, icon: Icon, shortcut }) => (
        <button
          key={id}
          onClick={() => setActiveTab(id)}
          className={clsx('tab', activeTab === id && 'active')}
          role="tab"
          aria-selected={activeTab === id}
          aria-controls={`panel-${id}`}
          title={`${label} (${shortcut})`}
        >
          <Icon className="w-4 h-4" />
          <span className="hidden sm:inline">{label}</span>
        </button>
      ))}
    </div>
  )
}
